<template>
  <vx-card no-shadow>

    <vs-input class="w-full mb-base" v-model="clubData.cancellation_time_period" icon-pack="feather" icon="icon-clock" label="Class cancellation time period" icon-no-border />
    

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2">Save Changes</vs-button>
    </div>
  </vx-card>
</template>

<script>
export default {
  data() {
    return {
      clubData : JSON.parse(localStorage.getItem("clubData")),
    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
  }
}
</script>
